import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ar from './locales/ar.json'

// Function to get initial language
const getInitialLocale = () => {
  const saved = localStorage.getItem('user-lang')
  if (saved) return saved
  return 'en'
}

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, ar },
})

// Watch for locale changes
const setAndPersistLocale = newLocale => {
  i18n.global.locale.value = newLocale
  localStorage.setItem('user-lang', newLocale)
}

// Export both i18n instance and setter function
export { i18n, setAndPersistLocale }
